import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { actionCreators } from "@App/state";
import { PresetFilterName } from "@App/types/presetFilters";

// Maps the Sixt `type` deeplink value (lowercased) to its preset filter.
// Lookups are case-insensitive so the link works regardless of how Sixt cases it.
const TYPE_PRESET_FILTER_MAP: Record<string, PresetFilterName> = {
  risk: PresetFilterName.SIXT_RISK,
  buyback: PresetFilterName.SIXT_BUY_BACK,
};

/**
 * Reads the `type` deeplink param and applies the matching preset filter.
 * The `brand` param (a raw brand id) is handled generically by
 * useVehicletreeParameters — see docs/sixt-brand-ids.csv for the id per brand.
 */
export const useTypeUrlParams = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { setPresetFilter } = bindActionCreators(actionCreators, dispatch);

  useEffect(() => {
    const type = searchParams.get("type")?.toLowerCase();
    const presetFilterName = type ? TYPE_PRESET_FILTER_MAP[type] : undefined;
    if (presetFilterName) {
      setPresetFilter([{ name: presetFilterName }]);
    }
  }, []);
};
